import { _ as _applyDecoratedDescriptor } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("{{#if this.isRow}}\n  <tr\n    class=\'tile-header\'\n    draggable=\'true\'\n    ...attributes\n    data-test-on-drag-start\n    {{on \'dragstart\' this.onDragStart}}\n  >\n    {{yield}}\n  </tr>\n{{else}}\n  <div\n    class=\'tile-header\'\n    draggable=\'true\'\n    ...attributes\n    data-test-on-drag-start-2\n    {{on \'dragstart\' this.onDragStart}}\n  >\n    {{yield}}\n  </div>\n{{/if}}");

var _class;
let BbDraggableComponent = (_class = class BbDraggableComponent extends Component {
  // The Classic component let a caller pick the wrapper tag (e.g.
  // scuolasci-project-edit renders rows with `@tagName='tr'` inside a table).
  // Glimmer has no dynamic tagName, so branch in the template; default `div`.
  get isRow() {
    return this.args.tagName === 'tr';
  }
  onDragStart(event) {
    return event.dataTransfer.setData('text/data', this.args.content);
  }
}, _applyDecoratedDescriptor(_class.prototype, "onDragStart", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onDragStart"), _class.prototype), _class);
setComponentTemplate(TEMPLATE, BbDraggableComponent);

export { BbDraggableComponent as default };
//# sourceMappingURL=bb-draggable.js.map
